import styled from "@emotion/styled";

export const SyncOperationText = styled.span`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;
